const TRUE_VALUES = new Set(["1", "true", "yes", "on", "enabled"]);

function isEnabled(value) {
  return TRUE_VALUES.has(String(value || "").trim().toLowerCase());
}

export const PHASE1_ENABLED = isEnabled(process.env.REACT_APP_PHASE1);
